import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";

export default class TackleStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Tackle &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const stats = [];

        let startPosition = play.contextSnapshot.fieldPosition;

        const isKickoffPlay = play.historyContains(FootballState.KickOff);

        const puntFragment = play.getFirstFragment(FootballState.Punt);
        const possessionSwitched =
            gameContext.homeTeamHasPossession !==
            play.contextSnapshot.homeTeamHasPossession;

        if (puntFragment && possessionSwitched) {
            startPosition = puntFragment.puntedTo;
        }

        const yards =
            (gameContext.fieldPosition - startPosition) *
            gameContext.getFieldDirectionMultiplier();
        fragment.tackledBy.forEach((player, i) => {
            const isUnassisted = fragment.tackledBy.length === 1;
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: player.teamId,
                    playerId: player.id,
                    driveId: gameContext.currentDriveId,
                    fragmentId: fragment.id,
                    category: FootballStatsCategory.TACKLE,
                    values: {
                        completed: 1,
                        unassisted: isUnassisted ? 1 : 0,
                        yards: !isKickoffPlay && i === 0 ? yards : undefined
                    }
                },
                stats
            );
        });

        return stats;
    }
}
